export default "__VITE_ASSET__BbsIC5Hi__"